import { render, staticRenderFns } from "./GraficaReportePostulacion.vue?vue&type=template&id=a2a9289a"
import script from "./GraficaReportePostulacion.vue?vue&type=script&lang=js"
export * from "./GraficaReportePostulacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports